export default __webpack_public_path__ + "static/media/menu_my_images.27578ee0.svg";